import 'css-chunksrc/client/pages/projectPortfoliosPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_1l7a1_1",
  "text": "_text_1l7a1_17",
  "icon": "_icon_1l7a1_21"
};